<template>
	<label>
		<em class="lt_text">Country</em>
		<span class="int_type_no_border mgr_5">
			<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="country" @post-loading="reset" @input="updateValue()" />
		</span>
	</label>
</template>

<script>
import CodeSelect from '@/components/common/CodeSelect';
import { apiSelectCountryList } from '@/api/search/search';

export default {
	name: 'CountrySelect',
	props: {
		value: {
			type: String,
		},
		bool: {
			type: Boolean,
		},
	},
	data: function() {
		return {
			countries: [],
			country: '',
		};
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.country = this.value;
			},
		},
	},
	computed: {
		defaultCountry: function() {
			let res = '';
			res = this.$session.get('company').ship_address_country;
			// ship_address_country가 유효하지 않은 경우, 미국으로 Default Set
			if (!this.isValidCountryCode(res)) res = this.findUSCode();
			return res;
		},
	},
	methods: {
		async selectData() {
			const { data } = await apiSelectCountryList();
			this.countries = data.value;

			this.$emit('default_country', this.defaultCountry);
			this.$emit('us_code', this.findUSCode());
		},
		isValidCountryCode(code) {
			return this.countries.findIndex(c => c.code === code) > -1;
		},
		findUSCode() {
			let res = '';

			if (this.isValidCountryCode('US')) res = 'US';
			else if (this.isValidCountryCode('USA')) res = 'USA';

			return res;
		},
		updateValue() {
			this.$emit('input', this.country);
		},
		reset() {
			if (!this.country) {
				this.country = !this.bool ? this.defaultCountry : '';
				this.updateValue();
			}
		},
	},
	components: {
		CodeSelect,
	},
	mounted() {
		this.selectData();
	},
};
</script>

<style scoped></style>
